var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsNumber, IsOptional, IsString, IsUUID, } from 'class-validator';
import { TreatmentLocation } from '../enums/treatment-location.enum.js';
import { UpdateCallPatientDto } from './update-call-patient.dto.js';
export class UpdateCallDto {
    id;
    plannedDuration;
    therapistId;
    treatmentLocation;
    scheduledStart;
    service;
    description;
    hasEnded;
    isCanceled;
    isInitialized;
    initializationTime;
    callSeriesId;
    isProposed;
    archiveDownloadTimestamp;
    callPatients;
}
__decorate([
    IsOptional(),
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UpdateCallDto.prototype, "id", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], UpdateCallDto.prototype, "plannedDuration", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UpdateCallDto.prototype, "therapistId", void 0);
__decorate([
    IsOptional(),
    IsEnum(TreatmentLocation),
    Expose(),
    __metadata("design:type", String)
], UpdateCallDto.prototype, "treatmentLocation", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Date)
], UpdateCallDto.prototype, "scheduledStart", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], UpdateCallDto.prototype, "service", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UpdateCallDto.prototype, "description", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateCallDto.prototype, "hasEnded", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateCallDto.prototype, "isCanceled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateCallDto.prototype, "isInitialized", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UpdateCallDto.prototype, "initializationTime", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UpdateCallDto.prototype, "callSeriesId", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateCallDto.prototype, "isProposed", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Date)
], UpdateCallDto.prototype, "archiveDownloadTimestamp", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    Type(() => UpdateCallPatientDto),
    __metadata("design:type", Array)
], UpdateCallDto.prototype, "callPatients", void 0);
//# sourceMappingURL=update-call.dto.js.map